import React from "react";
import PropTypes from "prop-types";
import { AppRowContainer } from "@crema";
import { Col } from "antd";
function ShowTaxManagement({ taxManagement }) {
  return (
    <AppRowContainer>
      <Col xs={8}>
        <p className="text-secondary">Tax Name</p>
      </Col>
      <Col xs={16}>
        <p>{taxManagement?.taxName}</p>
      </Col>
      <Col xs={8}>
        <p className="text-secondary">Tax Country</p>
      </Col>
      <Col xs={16}>
        <p>{taxManagement?.countryCode}</p>
      </Col>
      <Col xs={8}>
        <p className="text-secondary">States</p>
      </Col>
      <Col xs={16}>
        <p>{taxManagement?.stateCodes}</p>
      </Col>
      <Col xs={8}>
        <p className="text-secondary">Tax Percentage</p>
      </Col>
      <Col xs={16}>
        <p>{taxManagement?.tarifPercentage}</p>
      </Col>
      <Col xs={8}>
        <p className="text-secondary">Kind Of Tax</p>
      </Col>
      <Col xs={16}>
        <p>{taxManagement?.kindOfTax}</p>
      </Col>
    </AppRowContainer>
  );
}

export default ShowTaxManagement;

ShowTaxManagement.propTypes = {
  taxManagement: PropTypes.object,
};
